import { DistributorCode } from 'src/app/shared/models/enum/distributorCode.enum';
import { transformBrand } from 'src/app/shared/utils/brandUtils';

export class CreateContextRequestBuilder {
  private requestData: any;

  constructor() {
    this.requestData = {
      codeReseau: null,
      codeOperation: 'DROIT_CREATE_DEVISS',
      idVendeur: 0,
      modeConnexion: 'COB',
      idGestionaire: 0,
      referenceDevis: null,
      produit: null,
      branche: 'MRH',
      souscripteur: {
        civilite: null,
        prenom: null,
        nom: null,
        dateNaissance: null,
        paysNaissance: null,
        departementNaissance: null,
        villeNaissance: null,
        adresse: null,
        adresse2: null,
        codePostal: null,
        ville: null,
        telephone: null,
        email: null,
        profil: null,
        typologieSouscripteur: 'p'
      },
      codeVendeur: DistributorCode.VY,
      nomVendeur: null,
      prenomVendeur: null,
      siteVendeur: '000001',
      canalVente: 'W',
      referenceContrat: null,
      typeContact: null,
      donneesPartenaire: null,
      partnerCode: null
    };
  }

  withProduit(produit: string | null): CreateContextRequestBuilder {
    this.requestData.produit = produit?.toUpperCase();
    return this;
  }

  withCodeVendeur(codeVendeur: string | null): CreateContextRequestBuilder {
    this.requestData.codeVendeur = transformBrand(codeVendeur ?? '');
    return this;
  }

  withPartnerCode(partnerCode: string | null): CreateContextRequestBuilder {
    this.requestData.partnerCode = partnerCode?.toUpperCase() ?? null;
    return this;
  }

  build(): any {
    return this.requestData;
  }
}
